module.exports = __webpack_public_path__ + "static/media/withdraw.129b57c7.svg";